import * as React from "react";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { REJECT_REASON_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { SEARCH_VIEW_WORKFLOW } from "../../../Consts";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IWorkflow } from "../../../types/IWorkflow";
import DropdownDataInput, { SizedDropdownDataInput } from "../../dropdownDataInput/DropdownDataInput";
import { CLOSE_SVG } from "../../../IconConsts";

export interface IRejectWorkflowViewModalProps {
    workflowFieldsData: IRepertoireComponentDataItem;
    workflow: IWorkflow;
    onApproveOrReject: (workflow: IWorkflow, approved: boolean) => void;
    title: string;
    modalMessage?: string;
}

export interface IRejectWorkflowViewProps {
    props: IRejectWorkflowViewModalProps;
    hideModal: typeof hideModal;
    lookupValues: ILookupDictionary;
}

const RejectWorkflowView: React.SFC<IRejectWorkflowViewProps> = ({ props, hideModal, lookupValues }) => {
    const { workflowFieldsData, workflow, onApproveOrReject } = props;

    const [rejectReason, setRejectReason] = React.useState('');

    const changeData = (value: any) => {
        setRejectReason(value);
    }

    const rejectButtonText: string = workflowFieldsData.fields.find(f => f.name === "workflowRejectConfirm").data;

    const onClickReject = () => {
        let workflowWithRejectReason = workflow;
        workflowWithRejectReason.rejectReason = rejectReason;
        onApproveOrReject(workflowWithRejectReason, false);
        hideModal();
    }
    return (
        <div className="repertoireModal">
            <div className={"modal"}>
                <div className='modal-header' style={{
                        background: "#38429C",
                        color: "white",
                        }}>
                        <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={() => hideModal()}>
                            <Dismiss20Regular title="Close" />
                        </button>
                        <h1 className="modal-title">{props.title}</h1>
                </div>
                <div className="fixedPart" />
                <div className="dynamicPart">
                    <div className="modalBody" >
                        <div className="modalBody modal-message">{props.modalMessage}</div>
                        <div className="searchView">
                            <div className="searchRow">
                                <DropdownDataInput
                                    options={lookupValues[REJECT_REASON_TYPE_LOOKUP].lookups}
                                    label={""}
                                    fieldName={"Reason"}
                                    value={rejectReason}
                                    changeData={changeData}
                                    allowNull={true}
                                    isHidden={false}
                                    componentInstance={SEARCH_VIEW_WORKFLOW}
                                />
                            </div>
                            <div className="searchRow">
                                <div className="form-group col-lg-4 col-lg-push-8 col-md-4 col-md-push-8 col-sm-6 col-sm-push-6 col-xs-12 col-xs-push-0">
                                    <button className="button btn-defaultPrimary"
                                        onClick={onClickReject}>
                                        {rejectButtonText}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="fixedPart" />
            </div>
        </div>
    );
};

export default RejectWorkflowView;